/**
 * On-Call Overrides API Services
 */

import datacentral from '@/utils/axios/datacentral'
import { ResponseArray, ResponseObject } from '@/types/shared'

export interface Override {
    oncall_override_id: number
    oncall_schedule_id: number
    oncall_rotation_id?: number
    override_date: string
    employee_id: number
    employee_name: string
    employee_code?: string
    time_from: string
    time_to: string
    reason?: string
    is_active: boolean
    created_at: string
}

export interface CreateOverridePayload {
    rotation_id?: number
    override_date: string
    employee_id: number
    time_from?: string
    time_to?: string
    reason?: string
}

export const getScheduleOverrides = async (
    scheduleId: number,
    startDate?: string,
    endDate?: string
): Promise<ResponseArray<Override>> => {
    const params = new URLSearchParams()
    if (startDate) params.append('start_date', startDate)
    if (endDate) params.append('end_date', endDate)

    const response = await datacentral.get<ResponseArray<Override>>(
        `/oncall/schedules/${scheduleId}/overrides?${params.toString()}`
    )
    return response.data
}

export const createOverride = async (payload: {
    scheduleId: number
    data: CreateOverridePayload
}): Promise<ResponseObject<Override>> => {
    const response = await datacentral.post<ResponseObject<Override>>(
        `/oncall/schedules/${payload.scheduleId}/overrides`,
        payload.data
    )
    return response.data
}

export const deleteOverride = async (
    overrideId: number
): Promise<ResponseObject<null>> => {
    const response = await datacentral.delete<ResponseObject<null>>(
        `/oncall/overrides/${overrideId}`
    )
    return response.data
}
